import React, { useEffect, useState } from "react";
import {
  Grid,
  IconButton,
  Paper,
  Typography,
  Menu,
  MenuItem,
  Button,
  TextField,
} from "@material-ui/core";
import { Page, Tabla } from "components";
import serviciosTablero from "utils/serviciosTablero";

const HistorialSolicitudFechas = ({
  idtablero,
  setCargando,
  setMensaje,
  ...props
}) => {
  const [data, setData] = useState([]);
  const cerrarMensaje = () => setMensaje({ open: false });
  const columnas = [
    { label: "Folio", name: "idsolicitud", filtrar: true },
    { label: "Fechas anteriores", name: "fechasAntiguas", filtrar: true },
    { label: "Fechas nuevas", name: "fechasNuevas", filtrar: true },
    { label: "Autorizado por", name: "nombreAutoriza", filtrar: true },
    { label: "Solicitante", name: "nombreSol", filtrar: true },
    { label: "Fecha de solicitud", name: "fcrea", filtrar: true },
  ];

  const getHistorial = () => {
    serviciosTablero.getHistorialCambiosFechas(
      (estatus, mensaje, data) => {
        if (estatus > 0) {
          setData(data);
        }
      },
      setCargando,
      { idtarjeta: props.idtarjeta }
    );
  };
  // Manejar la acción de aceptar

  // Manejar la acción de declinar

  useEffect(() => {
    getHistorial();
  }, []);
  return (
    <Grid container spacing={1}>
      <Grid xs={12}>
        <Tabla columns={columnas} rows={data} usarEstilosTablero={true} />
      </Grid>
    </Grid>
  );
};

export default HistorialSolicitudFechas;
